<template>
    <div>
        <Row type="none" class="bg-white rounded shadow py-4">

            <Modal
                :text="modalText"
                id="modal_show"
                :on-ok-pressed="modalOk"
            />

            <div class="container font-bold text-gray-500 text-2xl">
                {{ $t('employee.personalInformation') }}
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4 container">
                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.givenName') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="givenName"
                        :model-form="modelForm"
                        :errors="errors"
                        check-to-model="modelNotEmptyState"
                        :column-no-top-margin="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.familyName') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="familyName"
                        :model-form="modelForm"
                        :column-is-fill="false"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.additionalName') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="additionalName"
                        :model-form="modelForm"
                        :column-is-fill="false"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.birthday') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        type="date"
                        model-name="birthday"
                        check-to-model="modelNotGreaterDate"
                        :model-form="modelForm"
                        :errors="errors"
                        :no-margin-top="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.telephone') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="telephone"
                        check-to-model="modelPhoneOrEmpty"
                        :model-form="modelForm"
                        :errors="errors"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.gender.title') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.gender" class="h-11 border-gray-300 focus:ring-0">
                        <b-form-select-option :value="1">{{ $t('person.gender.man') }}</b-form-select-option>
                        <b-form-select-option :value="0">{{ $t('person.gender.woman') }}</b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute -top-3 ml-2">
                        {{ $t('person.otherInformation') }}
                    </div>
                    <textarea
                        class="border-gray-300 focus:ring-0 rounded w-full"
                        id="exampleFormControlTextarea1"
                        v-model="modelForm.additionalInformation"

                    ></textarea>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute -top-3 ml-2">
                        {{ $t('employee.telegram') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="telegramProfile"
                        :model-form="modelForm"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div>
                        <label for="image" class="btn btn-primary w-full h-11">
                    <span
                        v-if="isLoadingError"
                        class="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                    >
                    </span>
                            <span class="font-bold">{{ $t('image.choiceImageFile') }}</span>
                        </label>
                        <input
                            id="image"
                            style="display: none"
                            type="file"
                            accept="image/*"
                            @change="importImage($event)"
                        >
                        <span
                            v-if="modelForm.image"
                            class="d-inline-block ml-2 pt-2 text-primary text-truncate"
                            style="max-width: 250px;"
                        >
                    {{ file.name }}
                    </span>
                        <span v-if="$route.name === 'employees/edit' && getEmployee.image">
                        <img :src="appUrl + getEmployee.image.contentUrl" alt="" class="profile-img">
                    </span>
                    </div>
                </div>
            </div>
        </Row>

        <Row type="none" class="bg-white rounded shadow mt-4 pb-3">

            <div class="container font-bold text-gray-500 text-2xl pt-4">
                {{ $t('employee.belongToApp') }}
            </div>

            <div class="grid grid-cols-12 gap-3 container py-4">
                <div class="col-span-12 md:col-span-6 relative">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.position') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <SelectBox
                        class="absolute -top-2 px-0"
                        :errors="errors"
                        :model-form="modelForm"
                        model-name="employeePosition"
                        getter-name="getEmployeePositions"
                        fetch-name="fetchEmployeePositions"
                        :after-fetch="afterFetchEmployeePositions"
                        check-to-model="modelNotEmptyState"
                        text-field="name"
                    />
                </div>
                <div class="col-span-12 md:col-span-2 relative mt-16 mt-md-0">
                    <ButtonTag :is-tw-main-btn=true :do-action="showPositionAddModal" :is-w100="true">
                        <TextTag>
                            &plus; {{ $t('new') }}
                        </TextTag>
                    </ButtonTag>
                </div>

                <div class="col-span-12 md:col-span-4 relative mt-4 mt-md-0">
                    <div @click="toggleCheckerAuth"
                         class="font-bold text-gray-500 absolute top-2 left-16 z-30 bg-transparent cursor-pointer">
                        {{ $t('employee.canAuth') }}
                    </div>
                    <input type="checkbox" id="switch" v-model="modelForm.canAuth">
                    <label for="switch" class="toggle-label z-20 w-full h-11 absolute top-0"></label>
                </div>
            </div>

            <div v-if="modelForm.canAuth" class="grid grid-cols-12 container">
                <div class="col-span-12 md:col-span-6 relative mt-4">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('user.email') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="email"
                        check-to-model="modelEmailState"
                        :errors="errors"
                        :model-form="modelForm"
                        :no-margin-top="true"
                    />
                </div>
            </div>

            <div v-if="modelForm.canAuth" class="grid grid-cols-12 gap-3 container py-5">
                <div v-for="(role, index) in employeeRoles" :key="index"
                     class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 relative">
                    <div @click="toggleCheckerRole(role.name), showModal(role.name)"
                         :class="roles[role.name] ? 'font-bold text-gray-500 text-xs z-30 absolute top-3 left-4 bg-transparent cursor-pointer' : 'font-bold text-gray-500 text-xs z-30 absolute top-3 right-4 bg-transparent cursor-pointer'">
                        {{ $t(role.text) }}
                    </div>
                    <input type="checkbox" v-model="roles[role.name]" :id="role.name" :class="role.name"/>
                    <label :for="role.name" class="toggle-label z-20 w-full h-full absolute top-0"></label>
                </div>
            </div>

        </Row>

        <Row type="none" class="bg-white rounded shadow mt-4">

            <div class="container font-bold text-gray-500 text-2xl pt-4">
                {{ $t('employee.workTimeAndSalary') }}
            </div>


            <div class="grid grid-cols-12 gap-3 container mt-4">
                <div class="col-span-12 md:col-span-4 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.hiredDate') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        type="date"
                        model-name="hiredDate"
                        check-to-model="modelNotGreaterDate"
                        :errors="errors"
                        :model-form="modelForm"
                        :no-margin-top="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.jobType.title') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.jobType" class="border-gray-300 h-11 focus:ring-0">
                        <b-form-select-option :value="0">{{ $t('employee.jobType.hourly') }}</b-form-select-option>
                        <b-form-select-option :value="1">{{ $t('employee.jobType.daily') }}</b-form-select-option>
                        <b-form-select-option :value="2">{{ $t('employee.jobType.weekly') }}</b-form-select-option>
                        <b-form-select-option :value="3">{{ $t('employee.jobType.monthly') }}</b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-12 md:col-span-4 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.jobSchedule.title') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.jobSchedule" class="border-gray-300 h-11 focus:ring-0">
                        <b-form-select-option :value="0">5 - 2</b-form-select-option>
                        <b-form-select-option :value="1">6 -1</b-form-select-option>
                        <b-form-select-option :value="2">7 - 0</b-form-select-option>
                        <b-form-select-option :value="3">4 -3</b-form-select-option>
                    </b-form-select>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 container mt-5">
                <div class="col-span-12 md:col-span-3 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.salary') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        model-name="salary"
                        check-to-model="modelNotEmptyState"
                        :errors="errors"
                        :model-form="modelForm"
                        :no-margin-top="true"
                        class="px-0"
                    />
                </div>

                <div class="col-span-12 md:col-span-3 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('currencyRate.choose') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.currency" class="border-gray-300 h-11 focus:ring-0">
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-12 md:col-span-3 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.workTimeFrom') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        type="time"
                        model-name="startTime"
                        check-to-model="modelNotEmptyState"
                        :errors="errors"
                        :model-form="modelForm"
                        class="px-0"
                    />
                </div>

                <div class="col-span-12 md:col-span-3 relative mt-4 mt-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.workTimeTo') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        type="time"
                        model-name="endTime"
                        check-to-model="modelNotEmptyState"
                        :errors="errors"
                        :model-form="modelForm"
                    />
                </div>
            </div>

            <div class="container mt-5 pb-4">
                <SubmitRow
                    v-if="canManageEmployees()"
                    :text="submitButtonName"
                    :is-loading="isLoading"
                    :is-disabled="hasErrors"
                    :do-action="addOrEdit"
                />
            </div>

        </Row>

        <!--  Can delete sale warning modal  -->
        <b-modal id="can-delete-sale" hide-footer>

            <!-- Modal body -->
            <div class="text-gray-500 font-bold text-xl py-4">
                {{ $t('customer.canDeleteSaleWarning') }}
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn rounded h-11 bg-denyColor border-0 hover:bg-hoverDenyColor focus:ring-0 w-32 font-bold text-white" data-dismiss="modal"
                        @click="canDeleteSale">{{ $t('yes') }}
                </button>
                <button type="button" class="btn rounded h-11 bg-main border-0 hover:bg-hoverMain focus:ring-0 w-32 font-bold text-white" data-dismiss="modal" @click="cantDeleteSale">
                    {{ $t('no') }}
                </button>
            </div>

        </b-modal>

        <!--  Add employee position modal  -->
        <b-modal id="add-position" hide-footer>

            <!-- Modal body -->
            <div class="grid grid-cols-12 mt-4">
                <div class="col-span-12 relative">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-5 ml-2">
                        {{ $t('employee.position') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="name"
                        check-to-model="modelNotEmptyState"
                        :model-form="modelFormPosition"
                        :errors="errorsPosition"
                    />
                </div>
            </div>

            <div class="mt-5 pb-3">
                <SubmitRow
                    v-if="canManageEmployees()"
                    :text="submitButtonName"
                    :is-disabled="hasErrorsPosition"
                    :is-loading="isLoading"
                    :do-action="add"
                    sm-size="12"
                    md-size="12"
                    class="px-0"
                />
            </div>

        </b-modal>
    </div>

</template>

<script>
import Row from "@/components/html/Row";
import InputBox from "@/components/InputBox";
import accessMixin from "@/mixin/accessMixin";
import SubmitRow from "@/components/SubmitRow";
import validatorMixin from "@/mixin/validatorMixin";
import {mapActions, mapGetters} from "vuex";
import Modal from "@/components/html/Modal";
import ButtonTag from "../../components/html/ButtonTag";
import TextTag from "../../components/html/TextTag";
import SelectBox from "@/components/SelectBox.vue";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "newAdd",
    mixins: [accessMixin, validatorMixin, currencyFormatMixin],
    components: {
        SelectBox,
        SubmitRow,
        InputBox,
        Row,
        Modal,
        ButtonTag,
        TextTag,
    },
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            employeeRoles: [
                {name: "ROLE_SELLER", text: 'role.ROLE_SELLER'},
                {name: "ROLE_STOREKEEPER", text: 'role.ROLE_STOREKEEPER'},
                {name: "ROLE_PRODUCT_PURCHASER", text: 'role.ROLE_PRODUCT_PURCHASER'},
                {name: "ROLE_PRODUCT_MANAGER", text: 'role.ROLE_PRODUCT_MANAGER'},
                {name: "ROLE_PRODUCT_PURCHASE_HISTORY", text: 'role.ROLE_PRODUCT_PURCHASE_HISTORY'},
                {name: "ROLE_SALE_HISTORY", text: 'role.ROLE_SALE_HISTORY'},
                {name: "ROLE_CUSTOMER_MANAGER", text: 'role.ROLE_CUSTOMER_MANAGER'},
                {name: "ROLE_EMPLOYEE_MANAGER", text: 'role.ROLE_EMPLOYEE_MANAGER'},
                {name: "ROLE_SEE_CUSTOMER_DEBTS", text: 'role.ROLE_SEE_CUSTOMER_DEBTS'},
                {name: "ROLE_DISCOUNT_MANAGER", text: 'role.ROLE_DISCOUNT_MANAGER'},
                {name: "ROLE_SERVICE_MANAGER", text: 'role.ROLE_SERVICE_MANAGER'},
                {name: "ROLE_KPI_MANAGER", text: 'role.ROLE_KPI_MANAGER'},
                {name: "ROLE_INVENTORY_MANAGER", text: 'role.ROLE_INVENTORY_MANAGER'},
                {name: "ROLE_CAN_DELETE_SALE_HISTORY", text: 'role.ROLE_CAN_DELETE_SALE_HISTORY'},
                {name: "ROLE_TAXES_MANAGER", text: 'role.ROLE_TAXES_MANAGER'},
                {name: "ROLE_AUTOORDER_MANAGER", text: 'role.ROLE_AUTOORDER_MANAGER'},
            ],
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees'},
                {name: this.$route.name === 'employees/edit' ? 'edit' : 'add'},
            ],
            modelForm: {
                id: null,
                familyName: '',
                givenName: '',
                additionalName: '',
                telephone: '',
                additionalInformation: '',
                gender: 1,
                telegram: '',
                salary: '',
                currency: 'UZS',
                jobSchedule: 1,
                jobType: 3,
                startTime: "08:00",
                endTime: "17:00",
                hiredDate: '',
                employeePosition: 0,
                birthday: '',
                canAuth: false,
                email: '',
                password: '',
                roles: [],
                image: null,
            },
            modelFormPosition: {
                name: null
            },
            errorsPosition: {
                name: null
            },
            errors: {
                givenName: null,
                telephone: null,
                gender: null,
                employeePosition: null,
                birthday: null,
                hiredDate: null,
                currency: null,
                jobType: null,
                jobSchedule: null,
                salary: null,
                startTime: null,
                email: null,
                password: null,
                endTime: null
            },
            roles: {
                ROLE_CUSTOMER_MANAGER: false,
                ROLE_EMPLOYEE_MANAGER: false,
                ROLE_PRODUCT_MANAGER: false,
                ROLE_PRODUCT_PURCHASER: false,
                ROLE_PRODUCT_PURCHASE_HISTORY: false,
                ROLE_SALE_HISTORY: false,
                ROLE_SELLER: false,
                ROLE_STOREKEEPER: false,
                ROLE_SEE_CUSTOMER_DEBTS: false,
                ROLE_CAN_DELETE_SALE_HISTORY: false,
                ROLE_DISCOUNT_MANAGER: false,
                ROLE_KPI_MANAGER: false,
                ROLE_INVENTORY_MANAGER: false,
                ROLE_TAXES_MANAGER: false,
                ROLE_AUTOORDER_MANAGER: false,
            },
            modalText: '',
            alertText: '',
            file: '',
            isLoading: false,
            submitButtonName: 'add',
            isLoadingError: false,
            alertInvalidImage: false,
        }
    },
    computed: {
        ...mapGetters(['getEmployee', 'getEmployeePositions', 'isEmailAvailable', 'getCurrencyByShortName']),
        hasErrorsPosition() {
            return this.modelFormPosition.name === null
        }
    },
    methods: {
        ...mapActions([
            'fetchEmployee',
            'pushEmployee',
            'pushPersonEmployee',
            'pushEmployeeImage',
            'checkEmailAvailability',
            'fetchRequestResetPassword',
            'pushEmployeePosition',
            'fetchEmployeePositions',
            'setBreadcrumbItems'
        ]),
        toggleCheckerRole(id) {
            document.getElementById(id).click()
        },
        toggleCheckerAuth() {
            document.getElementById('switch').click()
        },
        add() {
            this.isLoading = true

            this.pushEmployeePosition(this.modelFormPosition)
                .then(() => {
                    this.fetchEmployeePositions({page: 1})
                        .then(() => {
                            this.isLoading = false
                            this.$bvModal.hide('add-position')

                            if (this.getEmployeePositions.length > 0) {
                                this.modelForm.employeePosition = this.getEmployeePositions[this.getEmployeePositions.length - 1].id
                            }
                        })
                        .catch((reason) => {
                            this.$bvModal.hide('add-position')
                            this.isLoading = false
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                })
                .catch((reason) => {
                    this.$bvModal.hide('add-position')
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        showPositionAddModal() {
            this.$bvModal.show('add-position')
        },
        modalOk() {
            if (this.modalText === this.$t('user.emailSentToEmployee')) {
                this.$i18nHelper.toUrl('employees')
            }
        },
        importImage(event) {
            this.alertInvalidImage = false
            this.isLoadingError = true
            this.file = event.target.files[0]

            const data = new FormData();

            data.append('file', this.file)

            this.pushEmployeeImage(data)
                .then((res) => {
                    this.modelForm.image = res['@id']
                    setTimeout(() => this.isLoadingError = false, 3000)
                })
                .catch((err) => {
                    this.isLoadingError = false;

                    if (err === 'file: Please upload a valid image') {
                        this.alertText = this.$t('image.validImage')
                    } else {
                        this.alertText = err
                    }

                    this.alertInvalidImage = true
                    this.file = null
                })
        },
        afterFetchEmployeePositions() {
            if (this.getEmployeePositions.length > 0) {
                this.modelForm.employeePosition = this.getEmployeePositions[0].id
            }
        },
        canDeleteSale() {
            this.roles.ROLE_CAN_DELETE_SALE_HISTORY = true
            this.$bvModal.hide('can-delete-sale')
        },
        cantDeleteSale() {
            this.roles.ROLE_CAN_DELETE_SALE_HISTORY = false
            this.$bvModal.hide('can-delete-sale')
        },
        showModal(role) {
            if (role === 'ROLE_CAN_DELETE_SALE_HISTORY') {
                if (this.roles.ROLE_CAN_DELETE_SALE_HISTORY) {
                    console.log('if')
                    this.$bvModal.show('can-delete-sale')
                }
            }
        },
        sendEmail() {
            this.fetchRequestResetPassword({email: this.modelForm.email, isNewEmployee: true})
                .then(() => {
                    this.isLoading = false
                    this.$root.showOverlay = false

                    this.modalText = this.$t('user.emailSentToEmployee')
                    this.$bvModal.show('modal_show')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.$root.showOverlay = false

                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        addOrEdit() {
            this.isLoading = true
            this.$root.showOverlay = true

            this.modelForm.roles = []

            this.makeRolesPack()

            // if this was edit page
            if (this.$route.params.id) {
                this.modelForm.currency = this.getCurrencyByShortName(this.modelForm.currency)['@id']

                this.pushPersonEmployee(this.modelForm)
                    .then(() => {
                        if (this.getEmployee.user) {
                            if (this.modelForm.email !== this.getEmployee.user.email) {
                                this.sendEmail()
                            } else {
                                this.$i18nHelper.toUrl('employees')
                            }
                        } else {
                            this.isLoading = false
                            this.$root.showOverlay = false

                            this.$i18nHelper.toUrl('employees')
                        }

                    })
                    .catch((reason) => {
                        this.isLoading = false
                        this.$root.showOverlay = false

                        if (reason.includes("Duplicate entry")) {
                            this.modalText = this.$t("user.errors.emailExists")
                        } else if (reason === 'You have not available credits') {
                            this.modalText = this.$t('error.overLimit')
                        } else {
                            this.modalText = reason
                        }

                        this.$bvModal.show('modal_show')
                    })

                return;
            }

            if (this.modelForm.canAuth) {
                this.checkEmailAvailability(this.modelForm.email)
                    .then(() => {
                        if (!this.isEmailAvailable) {
                            this.isLoading = false
                            this.$root.showOverlay = false

                            // todo need alert component. flash not been seen
                            this.modalText = this.$t("user.errors.emailExists")
                            this.$bvModal.show('modal_show')

                            return
                        }

                        this.modelForm.currency = this.getCurrencyByShortName(this.modelForm.currency)['@id']

                        this.pushPersonEmployee(this.modelForm)
                            .then(() => {
                                if (this.modelForm.email !== '') {
                                    this.sendEmail()
                                } else {
                                    this.$i18nHelper.toUrl('employees')
                                }
                            })
                            .catch((reason) => {
                                this.isLoading = false
                                this.$root.showOverlay = false

                                if (reason === 'You have not available credits') {
                                    this.modalText = this.$t('error.overLimit')
                                    this.$bvModal.show('modal_show')
                                } else {
                                    this.modalText = reason
                                    this.$bvModal.show('modal_show')
                                }
                            })
                    })
                    .catch((reason) => {
                        this.isLoading = false
                        this.$root.showOverlay = false

                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            } else {
                this.modelForm.currency = this.getCurrencyByShortName(this.modelForm.currency)['@id']

                this.pushPersonEmployee(this.modelForm)
                    .then(() => {
                        if (this.modelForm.email !== '') {
                            this.sendEmail()
                        } else {
                            this.$i18nHelper.toUrl('employees')
                        }
                    })
                    .catch((reason) => {
                        this.isLoading = false
                        this.$root.showOverlay = false

                        if (reason === 'You have not available credits') {
                            this.modalText = this.$t('error.overLimit')
                            this.$bvModal.show('modal_show')
                        } else {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        }
                    })
            }
        },
        makeRolesPack() {
            if (this.roles.ROLE_CUSTOMER_MANAGER) {
                this.modelForm.roles.push('ROLE_CUSTOMER_MANAGER')
            }

            if (this.roles.ROLE_EMPLOYEE_MANAGER) {
                this.modelForm.roles.push('ROLE_EMPLOYEE_MANAGER')
            }

            if (this.roles.ROLE_PRODUCT_MANAGER) {
                this.modelForm.roles.push('ROLE_PRODUCT_MANAGER')
            }

            if (this.roles.ROLE_PRODUCT_PURCHASER) {
                this.modelForm.roles.push('ROLE_PRODUCT_PURCHASER')
            }

            if (this.roles.ROLE_PRODUCT_PURCHASE_HISTORY) {
                this.modelForm.roles.push('ROLE_PRODUCT_PURCHASE_HISTORY')
            }

            if (this.roles.ROLE_SALE_HISTORY) {
                this.modelForm.roles.push('ROLE_SALE_HISTORY')
            }

            if (this.roles.ROLE_SELLER) {
                this.modelForm.roles.push('ROLE_SELLER')
            }

            if (this.roles.ROLE_STOREKEEPER) {
                this.modelForm.roles.push('ROLE_STOREKEEPER')
            }

            if (this.roles.ROLE_SEE_CUSTOMER_DEBTS) {
                this.modelForm.roles.push('ROLE_SEE_CUSTOMER_DEBTS')
            }

            if (this.roles.ROLE_CAN_DELETE_SALE_HISTORY) {
                this.modelForm.roles.push('ROLE_CAN_DELETE_SALE_HISTORY')
            }

            if (this.roles.ROLE_INVENTORY_MANAGER) {
                this.modelForm.roles.push('ROLE_INVENTORY_MANAGER')
            }

            if (this.roles.ROLE_KPI_MANAGER) {
                this.modelForm.roles.push('ROLE_KPI_MANAGER')
            }

            if (this.roles.ROLE_TAXES_MANAGER) {
                this.modelForm.roles.push('ROLE_TAXES_MANAGER')
            }

            if (this.roles.ROLE_AUTOORDER_MANAGER) {
                this.modelForm.roles.push('ROLE_AUTOORDER_MANAGER')
            }
        }
    },
    watch: {
        modelForm() {
            this.hasErrorsIn(this.errors)
        },
        'modelForm.canAuth'(value) {
            if (!value) {
                this.errors.email = ''
                this.errors.password = ''
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.params.id) {
            this.$root.showOverlay = true

            this.fetchEmployee(this.$route.params.id)
                .then(() => {
                    if (this.getEmployee) {
                        this.submitButtonName = 'edit'
                        this.modelForm.id = this.getEmployee.id
                        this.modelForm.familyName = this.getEmployee.familyName
                        this.modelForm.givenName = this.getEmployee.givenName
                        this.modelForm.additionalName = this.getEmployee.additionalName
                        this.modelForm.telephone = this.getEmployee.telephone
                        this.modelForm.gender = this.getEmployee.gender
                        this.modelForm.additionalInformation = this.getEmployee.additionalInformation
                        this.modelForm.birthday = this.getEmployee.birthday?.slice(0, 10)

                        setTimeout(() => {
                            for (let ep of this.getEmployee.employeePositions) {
                                this.modelForm.employeePosition = ep.id
                            }
                        }, 1500)


                        if (this.getEmployee.image) {
                            this.modelForm.image = this.getEmployee.image['@id']
                        }

                        if (this.getEmployee.user) {
                            this.modelForm.canAuth = true
                            this.modelForm.email = this.getEmployee.user.email

                            for (let role of this.getEmployee.user.roles) {
                                this.roles[role] = true
                            }
                        }

                        if (this.getEmployee.employeeInformation) {
                            this.modelForm.telegram = this.getEmployee.employeeInformation.telegram
                            this.modelForm.hiredDate = this.getEmployee.employeeInformation.hiredDate.slice(0, 10)
                            this.modelForm.jobType = this.getEmployee.employeeInformation.jobType
                            this.modelForm.jobSchedule = this.getEmployee.employeeInformation.jobSchedule
                            this.modelForm.salary = this.getEmployee.employeeInformation.salary
                            this.modelForm.currency = this.getEmployee.employeeInformation.currency.shortName
                            this.modelForm.startTime = this.getEmployee.employeeInformation.startTime
                            this.modelForm.endTime = this.getEmployee.employeeInformation.endTime
                        }
                    }
                })
        } else {
            this.modelForm.currency = this.currentCurrencyShortName
        }

        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}`;
        this.modelForm.hiredDate = formattedDate
    },
}
</script>

<style scoped>
.profile-img {
    max-height: 50px;
    margin-left: 20px;

}

input[type=checkbox] {
    height: 0;
    width: 0;
    visibility: hidden;
}

.toggle-label {
    cursor: pointer;
    text-indent: -9999px;
    background: #E5E5E5;
    display: block;
    border-radius: 5px;
}

.toggle-label:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 45px;
    height: 100%;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
}

input:checked + .toggle-label {
    background: #bada55;
}

input:checked + .toggle-label:after {
    left: calc(100% - 0px);
    transform: translateX(-100%);
}

.toggle-label:active:after {
//width: 130px;
}

</style>
